import { Controller } from "@hotwired/stimulus";

declare global {
    interface FocusOptions {
        focusVisible?: boolean;
    }
}

export default class extends Controller {
    static override targets = ["popover"];
   
    declare popoverTarget: HTMLElement;
    
    public show() {
        this.popoverTarget.showPopover();
    }

    public hide() {
        this.popoverTarget.hidePopover();
    }

    // Focus the mouse caused, from hideOnMouseLeave or a click, does not match :focus-visible and must not reopen the
    // tooltip. Tab onto the button matches :focus-visible and opens it.
    public showOnFocus(event: Event) {
        if ((event.currentTarget as HTMLElement).matches(":focus-visible"))
            this.show();
    }

    // el-popover closes an open popover when focus lands outside it and its button. The focus it returns one tick after
    // a close would land on this button while the next button's tooltip, opened by the same mouse move, is open.
    // Focusing the button here first leaves nothing to return: el-popover returns focus only from the body or from
    // inside the popover. Its own return is keyboard-looking after any key press, which would show a focus ring and
    // reopen the tooltip through showOnFocus. focusVisible: false keeps this focus from doing either.
    public hideOnMouseLeave(event: Event) {
        const focused = document.activeElement;
        if (this.popoverTarget.matches(":popover-open") && (focused === document.body || this.popoverTarget.contains(focused)))
            (event.currentTarget as HTMLElement).focus({ focusVisible: false });

        this.hide();
    }

    // A click on the button would run its popovertarget toggle, which closes the tooltip that hovering or focusing it
    // just opened. el-popover handles Enter and Space itself, so the keyboard never reaches this handler.
    public openOnClick(event: Event) {
        event.preventDefault();

        if (!this.popoverTarget.matches(":popover-open"))
            this.show();
    }
}